import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-comment",
  "use": "icon-comment-usage",
  "viewBox": "0 0 28 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 24\" id=\"icon-comment\">\n  <g transform=\"translate(0.8, 0)\">\n    <path d=\"M22.2,3 L22.2,16 L15.8666667,16 L11.2,19.5 L11.2,16 L4.2,16 L4.2,3 L22.2,3 Z\" stroke=\"currentColor\" stroke-width=\"2\" fill=\"none\" />\n    <circle cx=\"8.2\" cy=\"9.5\" r=\"1.5\" />\n    <circle cx=\"13.2\" cy=\"9.5\" r=\"1.5\" />\n    <circle cx=\"18.2\" cy=\"9.5\" r=\"1.5\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol